// The user_document_ids an upload saved, in field order. A file the upload
// did not store (signed out, or refused by the document guard) has a null
// id and stored: false, and is left out: the quiz is generated without it.
const FIELDS = ['specification', 'past_paper'];

export function uploadedDocumentIds(uploadResult) {
  const documents = uploadResult?.documents || {};
  return FIELDS
    .map((field) => documents[field])
    .filter((doc) => doc && doc.stored && doc.user_document_id)
    .map((doc) => doc.user_document_id);
}

export default uploadedDocumentIds;
